<div class="rt-register" [class.close]="shouldClose">
        <section class="header-section">
            <span class="close header-btn" (click)="onCloseClicked()"></span>
            <span style="width: 66%; float: right;">
                <h1>{{'raciTemplate.editTitle' |  translate | uppercase}}</h1>
            </span>
        </section>
<raci-template-form [id]="selectedTemplateId" (closeWithRefresh)="onCloseWithRefresh()"></raci-template-form>
</div>